import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const SearchTemplate = htmlE`
  <form id="searchModalForm" class="search-modal">
    <div class="search-modal-keyword-field">
      <label data-i18n-key="keywords" for="searchKeywordInput" class="text-sm text-primaryMain">
        keywords
      </label>
      <input
        id="searchKeywordInput"
        name="keyword"
        class="input modal-input search-modal-keyword-input" />
    </div>

    <div class="search-modal-options">
      <div class="search-modal-option-group">
        <div class="search-modal-option">
          <input
            id="orSearch"
            checked
            name="include_type"
            type="radio"
            value="or" />
          <label
            data-i18n-key="or"
            for="orSearch"
            class="text-sm text-primaryMain">
            or
          </label>
        </div>
        <div class="search-modal-option">
          <input id="andSearch" name="include_type" type="radio" value="and" />
          <label
            data-i18n-key="and"
            for="andSearch"
            class="text-sm text-primaryMain">
            and
          </label>
        </div>
      </div>
      <div class="search-modal-options-divider"></div>
      <div class="search-modal-option-group">
        <div class="search-modal-option">
          <input id="exactSearch" name="exact" value="true" type="checkbox" />
          <label
            data-i18n-key="exact"
            for="exactSearch"
            class="text-sm text-primaryMain">
            exact?
          </label>
        </div>
        <div class="search-modal-option">
          <input
            id="keywordsOnlySearch"
            name="keywords_only"
            value="true"
            type="checkbox" />
          <label
            data-i18n-key="searchKeywordOnly"
            for="keywordsOnlySearch"
            class="text-sm text-primaryMain">
            searchKeywordOnly
          </label>
        </div>
      </div>
    </div>

    <div class="search-modal-filters">
      <div class="search-modal-filter-row">
        <div class="search-modal-field">
          <input name="date2" id="dateSearch2" value="true" type="checkbox" />
          <label for="dateSearch2" class="text-sm text-primaryMain">
            <span data-i18n-key="after">after</span>
          </label>
          <div class="search-modal-date-wrap" id="modified-2-wrap">
            <input type="hidden" name="date2_action" value="after" />
            <input
              name="date2_value"
              id="modified-2"
              class="input modal-input date-input"
              type="text"
              placeholder="${"dateFormatText"}"
              data-input />
            <button type="button" class="search-modal-calendar-btn" data-toggle>
              <i class="icon-calendar"></i>
            </button>
          </div>
        </div>

        <div class="search-modal-field">
          <input name="date1" id="modifiedSearch1" value="true" type="checkbox" />
          <label for="modifiedSearch1" class="text-sm text-primaryMain">
            <span data-i18n-key="before">before</span>
          </label>
          <div class="search-modal-date-wrap" id="modified-1-wrap">
            <input type="hidden" name="date1_action" value="before" />
            <input
              id="modified-1"
              name="date1_value"
              class="input modal-input date-input"
              type="text"
              placeholder="${"dateFormatText"}"
              data-input />
            <button type="button" class="search-modal-calendar-btn" data-toggle>
              <i class="icon-calendar"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="search-modal-filter-row">
        <div class="search-modal-field">
          <input name="size1" id="sizeSearch1" value="true" type="checkbox" />
          <label
            data-i18n-key="biggerThan"
            for="sizeSearch1"
            class="text-sm text-primaryMain">
            Bigger than
          </label>
          <input type="hidden" name="size1_action" value="bigger than" />
          <input
            name="size1_value"
            id="size-1"
            class="input modal-input kb-input" />
          <span class="text-xs text-secondaryMain search-modal-unit" data-i18n-key="kilobytes">
            Kilobytes
          </span>
        </div>

        <div class="search-modal-field">
          <input name="size2" id="sizeSearch2" value="true" type="checkbox" />
          <label
            data-i18n-key="smallerThan"
            for="sizeSearch2"
            class="text-sm text-primaryMain">
            Smaller than
          </label>
          <input type="hidden" name="size2_action" value="smaller than" />
          <input
            name="size2_value"
            id="size-2"
            class="input modal-input kb-input" />
          <span class="text-xs text-secondaryMain search-modal-unit" data-i18n-key="kilobytes">
            Kilobytes
          </span>
        </div>
      </div>

      <div class="search-modal-field search-modal-type-field">
        <input name="type1" id="typeSearch1" value="true" type="checkbox" />
        <label
          data-i18n-key="typeIsA"
          for="typeSearch1"
          class="text-sm text-primaryMain">
          typeIsA
        </label>
        <div class="select search-modal-type-select">
          <select name="type1_action" class="primary-select">
            <option selected data-i18n-key="file" value="file">file</option>
            <option data-i18n-key="folder" value="folder">folder</option>
          </select>
        </div>
      </div>
    </div>
    <button type="submit" class="is-hidden"></button>
  </form>
`;

export const searchPollingTemplate = htmlE`
  <div>
    <div
      class="is-flex is-justify-content-center is-align-items-center gap-3 mb-3">
      <span>
        <span data-i18n-key="searching">Searching</span>
        <span>...</span>
      </span>
      <button
        id="abortSearchAction"
        class="primary-button is-bg-none p-0"
        data-i18n-key="cancel">
        Cancel
      </button>
    </div>

    <progress
      class="progress success-progress poll-search-status-progress"
      value="0"
      max="100"></progress>
  </div>
`;

export default SearchTemplate;
